import React, { useEffect, useState } from 'react';
import './App.css';
import './pageComponents/ipData.css';
import './blogTextFormatting.css';
import './style-guide.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import NavBar from './pageComponents/NavBar.js';
import IpData from './pageComponents/ipData.js';
import About from './Pages/about.js';
import Home from './pageComponents/ipData.js';
import RoadMap from './pageComponents/roadMap.js';
import Header from './pageComponents/Header.js';



function App() {
  const [selectedOption, setSelectedOption] = useState('MissionStatement');
  const [isOpen, setIsOpen] = useState(false);



  // Initialize dark mode state so that dark mode is enabled by default
  const [darkMode, setDarkMode] = useState(() => {
    const savedMode = localStorage.getItem("darkMode");
    if (savedMode === null) {
      localStorage.setItem("darkMode", "enabled");
      return true;
    }
    return savedMode === "enabled";
  });

  // Toggle Dark Mode
  const toggleDarkMode = () => {
    const newMode = !darkMode;
    setDarkMode(newMode);
    localStorage.setItem("darkMode", newMode ? "enabled" : "disabled");
  };

  // Apply Dark Mode
  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }
  }, [darkMode]);

  useEffect(() => {
    console.log("Option in IpData:", selectedOption);
  }, [selectedOption]);

  const toggleSidebar = () => {
    setIsOpen((prev) => !prev);
  };

  const handleNavBarSelection = (value) => {
    // Update the selected menu item based on the value received from NavBar
    setSelectedOption(value);
  };

  const renderContent = () => {
    switch (selectedOption) {
      case 'Home':
        return <IpData />;
      case 'About':
        return <About
          localLinkHandler={handleNavBarSelection}
        />;
case 'FeatureDetails':
        return <RoadMap
          localLinkHandler={handleNavBarSelection}
        />;

      case 'Roadmap':
        return <RoadMap
          localLinkHandler={handleNavBarSelection}
        />;
      // Add more cases as needed
      default:
        return <Home />; // Default if no case matches
    }
  };



  return (
    <>
      <div className={`App ${darkMode ? "dark-mode" : ""} ${isOpen ? "sidebar-open" : ""}`}>
        {/* Full-width Header */}
        <Header
          darkMode={darkMode}
          toggleDarkMode={toggleDarkMode}
        />

        {/* Container for the rest of the content */}
        <div className="container">
          {/* NAV BAR: Passing isOpen, toggleSidebar, and onNavItemClick */}
          <NavBar
            isOpen={isOpen}
            toggleSidebar={toggleSidebar}
            onNavItemClick={handleNavBarSelection} />

          {/* RENDERED CONTENT */}
          <div className="renderedContent">
            {renderContent()}

          </div>
        </div>


        <div className='footer'>
          {/* FOOTER */}
          <footer className="footer">
            <p>iv4.io | The Future of SysAdmin Tools</p>

          </footer>


        </div>

      </div>

    </>
  );


}

export default App;
